import { type VoidFunctionComponent } from 'react';

import { useGetMalwareInfo } from '../../../../hooks/api/malware';
import { Link } from '../../../generic';
import Loader from '../../../generic/Loader';

type MalwareDescriptionProps = {
  malwareRevisionId: number;
};

/**
 * Displays malware information
 * Shows the malware report name, description, and a link to the report URL
 */
const MalwareDescription: VoidFunctionComponent<MalwareDescriptionProps> = ({
  malwareRevisionId,
}) => {
  const { data: malwareInfo, isLoading, isError } = useGetMalwareInfo(malwareRevisionId);

  if (isLoading) {
    return <Loader />;
  }

  if (isError || !malwareInfo) {
    return (
      <div>
        This dependency has been flagged as malicious, but additional details are not available at this time.
      </div>
    );
  }

  return (
    <>
      <div className="padding-top-xs">
        <strong>{malwareInfo.name}</strong>
      </div>

      <div>
        {malwareInfo.description}
      </div>

      <div className="padding-top-md">
        <strong>Read more:</strong>&nbsp;
        <Link to={malwareInfo.url} variant="text" openInNewTab>
          {malwareInfo.url}
        </Link>
      </div>
    </>
  );
};

export default MalwareDescription;
